<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Survey & Referral</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Marketing</b>
      /
      <b>Survey & Referral</b>
      /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title"><b>Details</b></h4>
            <hr>

            <div class="col-8">
              <div class="form-group">
                <label>Type:</label><br>
                <label class="ml-2">{{ event.name }}</label>
              </div>

              <div class="form-group">
                <label>Points Earned:</label>
                <input class="form-control" v-model="event.points">
              </div>
            </div>

            <div class="row" style="margin-top: 30px;">
              <div class="col-12 text-center">
                <button class="btn btn-rounded btn-primary col-3" @click="update()">Save</button>
              </div>
            </div>
          </div>
        </div>
        <SurveyReferralLogs :data="eventLogs" />
      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";
import SurveyReferralLogs from "./Logs.vue";

export default {
  name: "surveyReferral-edit",
  components: {
    SurveyReferralLogs
  },

  data() {
    return {
      event: [],
      eventLogs: []
    };
  },

  methods: {
    loadEvent() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/event/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.event = res.data.event;
          })
      }
    },

    update() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        swal({
          icon: 'warning',
          text: 'Are you sure?',
          buttons: ['Cancel', 'Yes']
        }).then((confirm) => {
          if (!confirm) {
            return;
          }
          axios
            .post(axios.lpsURL + "/event/update",
              {
                id: id,
                name: this.event.name,
                points: this.event.points
              },
              {
                headers: {
                  Authorization: "Bearer " + token
                }
              })
            .then(res => {
              if (res.data.success) {
                swal({
                  icon: "success",
                  title: "Success",
                  text: res.data.message
                })
                  .then(() => {
                    this.$router.push("/marketing/survey-referral")
                  })

              } else {
                swal({
                  icon: "error",
                  title: "Fail",
                  text: res.data.message
                })
              }
            })
        })

      }
    },
    loadEventLogs() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/event/log/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.eventLogs = res.data.data;
            console.log('res', res.data.data);
          })
      }
    },
  },

  mounted() {
    this.loadEvent()
    this.loadEventLogs()
  }
};
</script>
